import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';

const today = new Date();
// var time_today = today.getTime();
// let now = new Date();
// const currentdat = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
  selector: 'app-prefrence-download',
  templateUrl: './prefrence-download.component.html',
  styleUrls: ['./prefrence-download.component.css']
})
export class PrefrenceDownloadComponent implements OnInit {

  maxDate: Date = new Date();
  minDate: Date = new Date();
  inValid: boolean;
  exDate: any = '';

  constructor(private fb: FormBuilder,
    private pd: APIImportPreferenceService,
    private $modal: $ModalManagerService,
  ) { }
  preferenceDownloadForm: FormGroup;
  get f() { return this.preferenceDownloadForm.controls; }
  ngOnInit() {

    this.preferenceDownloadForm = this.fb.group({
      ExpiryDate: ['', Validators.required]
    })

    this.minDate.setDate(today.getDate() - 30);
    this.maxDate.setDate(today.getDate() - 1);

  }

  onSubmit() {

    var selDate = new Date(this.preferenceDownloadForm.get('ExpiryDate').value);
    // this.exDate = selDate.getDate()+  (selDate.getMonth()+1) + selDate.getFullYear();
	//this.exDate = selDate.getFullYear() + "-" + (selDate.getMonth()+1) + "-" +selDate.getDate();
    //this.exDate = selDate.getDate() + '' + (selDate.getMonth() + 1) + '' + selDate.getFullYear()
   // console.log("passing Expiry date   ", this.exDate);

    // console.log("date   ",selDate);
    //let date = formatDate(this.date, 'yyyy-MM-dd', 'en-US', '+0530');
    //let date = this.date;
    //console.log("date  ",date); 
    // let date = '2019-04-17';
    // console.log("date  ", date);
	var day;
	var months;
	var month;
	var year;           
       day=	selDate.getDate().toString();   
	   months=selDate.getMonth()+1; 
      	month=months.toString();   
	   year=selDate.getFullYear().toString();   
	   this.exDate = day+month+year;   
       console.log("DAte=========>"+this.exDate); 	
    console.log("date checking", this.preferenceDownloadForm.get('ExpiryDate').value)
    if (this.preferenceDownloadForm.get('ExpiryDate').value === undefined) {
      this.inValid = true;
      this.$modal.errorModal({
        title: '',
        msg: 'Please select vaid date'
      });

    }
    else {

	 // this.exDate = "2019-9-13"
      this.pd.getPreferenceDownload(this.exDate).subscribe(r => {
        console.log("The status is ", r)
        //var ranvalue = today.getTime();
        var fileName = this.exDate + '.csv';
        console.log("fileName : ", fileName);
        importedSaveAs(r, fileName)


        console.log("getPreferenceDownload : ", r);
        console.log("getPreferenceDownload stringify : ", JSON.stringify(r));
        const url = window.URL.createObjectURL(r);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = fileName;
        /*  a.click();
         window.URL.revokeObjectURL(url);
         a.remove(); */

        console.log(r.status)
        // if(r.status == "success"){
        if (r) {
          this.$modal.successModal({
            title: 'Preference Download',
            msg: 'Preference File has been downloaded Successfully'
          });
        }
        else if (r.error) {
          this.$modal.successModal({
            title: 'Preference Download',
            msg: 'Could not download Preference File'
          });
        }
      },
        (error) => {

          this.$modal.errorModal({
            title: 'Preference Download',
            msg: 'File not processed'
          });
          console.log("error=== " + error.status)
          // console.log("error=== " + Response)


          // console.log("response=== " + response)
          // console.log("request=== " + request)
        }

      );
    }

  }

}
